import type { Spread } from '@/api/types/spread'

/** The printed page numbers either side of a spread's spine; null where that page doesn't exist. */
export type SpreadPageIndicator = { left: number | null; right: number | null }

/** Page numbers for the menubar center indicator (handles duplicate spread indices). */
export function spreadPagesForMenubarIndicator(
  spread: Spread | null
): SpreadPageIndicator | undefined {
  if (!spread?.pages?.length) return undefined

  const sorted = [...spread.pages].sort((a, b) => (a.number ?? 0) - (b.number ?? 0))

  if (sorted.length === 1) {
    const p = sorted[0]
    const n = typeof p.number === 'number' ? p.number : null

    if (n == null) return undefined

    return p.leftPage === true ? { left: n, right: null } : { left: null, right: n }
  }

  const leftP = sorted.find((p) => p.leftPage === true) ?? sorted[0]
  const rightP = sorted.find((p) => p.leftPage === false) ?? sorted[1]
  const ln = typeof leftP?.number === 'number' ? leftP.number : null
  const rn = typeof rightP?.number === 'number' ? rightP.number : null

  return { left: ln, right: rn }
}
